import type { SVGProps } from 'react';
const SvgPieChartOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#pie_chart_outlined_svg__a)">
      <path
        fill="currentColor"
        d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2Zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07ZM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94Zm9 7.93V13h6.93A8.002 8.002 0 0 1 13 19.93Z"
      />
    </g>
    <defs>
      <clipPath id="pie_chart_outlined_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPieChartOutlined;
